import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * @deprecated Use semantic layout instead.  See c4-assets.
 */
@Component({
  selector: 'prg-block-button,[prg-block-button]',
  templateUrl: './block-button.component.html',
  styleUrls: ['./block-button.component.less']
})
export  class BlockButtonComponent implements OnInit {

  @Input() leadingIcon: string;
  @Input() trailingIcon: string;

  /** @deprecated use buttonClass instead */
  @Input() foreground: string;
  /** @deprecated use buttonClass instead */
  @Input() background: string;
  @Input() buttonClass: string;
  @Input() badge: string;
  @Input() textClass: string;

  @Output() trailingClicked: EventEmitter<any>;
  @Output() leadingClicked: EventEmitter<any>;

  constructor() {
    this.trailingClicked = new EventEmitter<any>();
    this.leadingClicked = new EventEmitter<any>();

    // this.background = this.background || '#3ba1c1';
    // this.foreground = this.foreground || '#efefef';
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/block-button/block-button.component.ts